import { ThemeOptions, createTheme } from '@mui/material/styles'
import { FontFamilyNames } from '@appTypes/fonts'
import { COLORS } from '@collections/colors'

const theme = createTheme()

export const typography: ThemeOptions['typography'] = (/* theme */) => ({
  fontFamily: FontFamilyNames.Inter,
  h1: {
    fontFamily: FontFamilyNames.InterExtraBold,
    fontWeight: 700,
    fontSize: '48px',
    lineHeight: '58px',
    letterSpacing: '-0.02em',

    [theme.breakpoints.down('md')]: {
      color: '#252525',
      fontFamily: 'Inter',
      fontSize: '32px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: 'normal',
      letterSpacing: '-0.64px'
    }
  },
  h2: {},
  h3: {},
  h4: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '29px',
    color: COLORS.raisinBlack
  },
  h5: {
    fontWeight: 600,
    fontSize: '15px',
    lineHeight: '140%',
    letterSpacing: '-0.01em',

    [theme.breakpoints.down('md')]: {
      fontSize: '13px'
    }
  },
  h6: {}
})
